import {interval, filter} from 'rxjs';
import {toUiMsg$, uiMsg$} from '@/ui';

export interface UElTrack {
  type: 'et-track';
  data: {
    event: string;
    params: Record<string, any>;
  };
}

let isReady: boolean = false;

uiMsg$.subscribe((msg: any) => {
  if (msg.type === 'ty-ready') {
    isReady = true;
  }
});

const messages: any[] = [];

export function track(event: string, params: Record<string, any>) {
  messages.push({event, params});
}

const interval$ = interval(150);

interval$.pipe(filter(() => isReady && messages.length > 0)).subscribe(() => {
  const {event, params} = messages[0];
  toUiMsg$.next({type: 'et-track', data: {event, params}});
  messages.shift();
});
